import Grid from "@material-ui/core/Grid";
import React from "react";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import { CircularProgress } from "@material-ui/core";
import { updateArticle, uploadArticleImage } from "../../../store/articles/ArticlesApi";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditImage from "../../EditArticle/EditImage";
import TablePagination from "@material-ui/core/TablePagination";

export default function UploadImagesArticlesDialog(props) {
  const articlegroups = props.articlegroups;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  if (!articlegroups) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let filteredArticlegroups = [];
  let skippedArticles = 0;
  let addedArticles = 0;
  articlegroups.some((articlegroup) => {
    filteredArticlegroups.push({ id: articlegroup.id, filteredArticleIds: [] });

    return articlegroup.getArticles(articlesStore.articles).some((article) => {
      if (page * rowsPerPage > skippedArticles) {
        skippedArticles++;
      } else {
        filteredArticlegroups[filteredArticlegroups.length - 1].filteredArticleIds.push(article.id);
        addedArticles++;
      }
      return addedArticles === rowsPerPage;
    });
  });

  let countAllArticles = 0;
  articlegroups.forEach((articlegroup) => articlegroup.articleIds.forEach((id) => countAllArticles++));

  return (
    <>
      <div style={{ margin: 20 }}>
        <TablePagination
          component="div"
          count={countAllArticles}
          page={page}
          onChangePage={handleChangePage}
          rowsPerPage={rowsPerPage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
        {filteredArticlegroups
          .filter((filteredArticlegroup) => filteredArticlegroup.filteredArticleIds.length > 0)
          .map((filteredArticlegroup) => {
            let articlegroup = articlesStore.articlegroups[filteredArticlegroup.id];
            return (
              <Grid item container xs={12} spacing={2} key={articlegroup.id}>
                <Grid item xs={12}>
                  <Typography>{articlegroup.name}</Typography>
                  <Divider />
                </Grid>
                <Grid item xs={12} spacing={5} container direction={"row"} style={{ width: "100%" }}>
                  {filteredArticlegroup.filteredArticleIds.map((articleId) => {
                    let article = articlesStore.articles[articleId];
                    return (
                      <Grid item xs={2} key={article.id + "-" + article.image}>
                        <Paper style={{ width: "100%", height: "100%", minHeight: 150, padding: 5 }}>
                          <Typography>{article.name}</Typography>
                          <EditImage
                            key={article.updatedAt}
                            authorizationField={"article.image"}
                            value={article.image}
                            prefix={"https://mynober-api-public.s3.eu-central-1.amazonaws.com/"}
                            onSave={(image, setImagePath) => {
                              uploadArticleImage(articlesStore.merchantId, article.id, image).then((image) => {
                                setImagePath("https://mynober-api-public.s3.eu-central-1.amazonaws.com/" + image);
                              });
                            }}
                            onRemove={(setImagePath) => {
                              updateArticle(articlesStore.merchantId, article, { image: null }).then((article) => {
                                setImagePath(article.image);
                              });
                            }}
                          />
                        </Paper>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            );
          })}
      </div>
    </>
  );
}
